import {
  Component,
  inject,
  Injector,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  AsyncPipe,
  NgClass,
  NgOptimizedImage,
  TitleCasePipe,
} from '@angular/common';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import {
  ContainerItemModel,
  ContainerItemOption,
  ContainerModel,
} from '@app/models/server/layout.model';
import { UID_CONSTANTS } from '@app/constants/forms.constants';
import { SelectedItem } from '@app/models/client/item.model';
// import { LoggerService } from '@app/services/util-services/logger.service';
import { StringUtilLibService } from '@b2b/string-util-lib';
import { FormHelperService } from '@app/new-ui-lib/b2b-search/components/b2b-desktop/b2b-shortstay-form/service/form-helper.service';
import { DateUtilLibModule, DayjsDateUtilLibService } from '@b2b/date-util-lib';
import {
  ApiResponseBody,
  NewRequestBodyModel,
} from '@app/models/client/new-request-body.model';
import { HttpErrorResponse } from '@angular/common/http';
import { SearchFormService } from '@app/services/feature-services/search-form/search-form.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EventService } from '@app/services/util-services/root-services/event-service';
import { FEATURE_TYPES, PAGE_TYPES } from '@app/constants/app-settings';
import { from, of, Subscription, switchMap } from 'rxjs';
import { AnalyticsEventService } from '@app/services/util-services/root-services/analytics-event-service';
import { ToastService } from '@app/services/util-services/root-services/toast-service';
import { DateModel } from '@app/models/client/date.model';
import { HttpClientService } from '@app/services/util-services/root-services/http-client.service';
import { B2bDynamicLoaderPipe } from '@app/b2b-dynamic-lib/pipes/b2b-dynamic-loader-pipe.pipe';
import { B2bDynamicLoaderDirective } from '@app/b2b-dynamic-lib/directives/b2b-dynamic-loader.directive';
import { environment } from '@src/environments/environment';
import { LoaderUtilService } from '@app/services/loader/loader-util.service';
import { SearchCompDataType } from '@app/new-ui-lib/b2b-search/types/search-comp-data.type';
import { B2bPopoverV1Component } from '@app/new-ui-lib/b2b-popover-v1/b2b-popover-v1.component';
import { ComponentRef, OverlayEventDetail } from '@ionic/core';
import { ModalController } from '@ionic/angular/standalone';
import {TapEffect} from '@app/components/directives/tap-effect.ts/tap-effect';

const LIST_SEARCH_EVENT = 'LIST_SEARCH_EVENT';
const DETAIL_SEARCH_EVENT = 'DETAIL_SEARCH_EVENT';

@Component({
  selector: 'app-b2b-shortstay-form',
  templateUrl: './b2b-shortstay-form.component.html',
  styleUrls: ['./b2b-shortstay-form.component.scss'],
  providers: [
    FormHelperService,
    StringUtilLibService,
    FormBuilder,
    DayjsDateUtilLibService,
  ],
  standalone: true,
  imports: [
    DateUtilLibModule,
    NgClass,
    ReactiveFormsModule,
    TitleCasePipe,
    AsyncPipe,
    NgOptimizedImage,
    B2bDynamicLoaderPipe,
    B2bDynamicLoaderDirective,
    B2bPopoverV1Component,
    TapEffect,
  ],
  // animations: [
  //   enterAnimationComponent,
  //   // enterAnimationImage
  // ],
})
export class B2bShortstayFormComponent implements OnInit, OnDestroy {
  @Input() compData: {
    container: ContainerModel;
  };

  finalContainer: ContainerModel;

  experienceTabs: ContainerModel[];

  pageTypes = PAGE_TYPES;

  UID_ENUMS = UID_CONSTANTS;

  date: Date = new Date();

  selectedCompData: SearchCompDataType;

  formGroup: FormGroup;

  submitFormSubscription$: Subscription;

  featureType: string;

  featureTypes = FEATURE_TYPES;

  @ViewChild('dateRangePopover') dateRangePopover: B2bPopoverV1Component;
  @ViewChild('checkinDatePopover') checkinDatePopover: B2bPopoverV1Component;
  @ViewChild('checkinTimePopover') checkinTimePopover: B2bPopoverV1Component;
  @ViewChild('hoursPopover') hoursPopover: B2bPopoverV1Component;
  @ViewChild('roomGuestPopover') roomGuestPopover: B2bPopoverV1Component;
  @ViewChild('localityPopover') localityPopover: B2bPopoverV1Component;

  initAPISubscription$: Subscription;

  pageType: string;

  injector: Injector;

  private loaderService: LoaderUtilService;

  modalController: ModalController;

  protected readonly environment = environment;

  constructor(
    private fb: FormBuilder,
    private formHelperService: FormHelperService,
    private dayjsDateUtilLibService: DayjsDateUtilLibService,
    private searchFormService: SearchFormService,
    private router: Router,
    private route: ActivatedRoute,
    private eventService: EventService,
    private analyticsEventService: AnalyticsEventService,
    private toastService: ToastService,
    private httpClientService: HttpClientService,
  ) {
    this.injector = inject(Injector);
    this.loaderService = inject(LoaderUtilService);
    this.modalController = inject(ModalController);
  }

  ngOnInit() {
    this.initApi();
  }

  initApi() {
    this.initAPISubscription$ = this.httpClientService
      ?.getDynamicContainersData(
        this.compData?.container?.apiURL,
        this.compData?.container?.isCacheEnabled,
        this.compData?.container?.key,
        this.compData?.container?.apiRequestBody,
        null,
        true,
      )
      .pipe(
        switchMap((containers: ContainerModel[]) => {
          if (containers?.length === 1) {
            if (containers[0]?.feature?.type === FEATURE_TYPES?.EXPERIENCES) {
              if (containers[0]?.containers?.length > 0) {
                const foundedContainer: ContainerModel =
                  containers[0]?.containers?.find((item) => item?.isActive);
                if (foundedContainer) {
                  this.finalContainer = foundedContainer;
                } else {
                  this.finalContainer = containers[0]?.containers[0];
                }
                this.experienceTabs = containers[0]?.containers;
              }
              this.pageType = containers[0]?.feature?.page;
              this.featureType = FEATURE_TYPES?.EXPERIENCES;
            } else {
              this.finalContainer = containers[0];
              this.pageType = this.finalContainer?.feature?.page;
            }
          } else {
            // TODO
          }
          return of(containers);
        }),
        // delay(1000),
      )
      .subscribe({
        next: (containers: ContainerModel[]) => {
          this.initForm();
        },
        error: (errorResponse: HttpErrorResponse) => {},
      });
  }

  changeExpTab(container: ContainerModel) {
    this.finalContainer = container;
  }

  initForm() {
    this.formGroup = this.createFormGroupFromCustomField(
      this.finalContainer?.data,
    );

    this.eventService.selectMenuCategoryEvent.emit({
      selectedTab: this.finalContainer?.feature?.type,
    });
  }

  dismissPopover(
    popover: B2bPopoverV1Component,
    currentCompData: {
      container: ContainerModel;
      containerItem: ContainerItemModel;
      selectedValue: SelectedItem;
    },
  ) {
    // LoggerService.log('Inside dismissPopover ', popover);
    popover?.close();
    this.openNextPopover(currentCompData);
  }

  openNextPopover(currentCompData: {
    container: ContainerModel;
    containerItem: ContainerItemModel;
    selectedValue: SelectedItem;
  }) {
    let index: number = Number(0);
    for (const containerItem of this.finalContainer?.data) {
      if (containerItem?.uid === currentCompData?.containerItem?.uid) {
        // add opening logic here
        if (index < this.finalContainer?.data?.length - 1) {
          // LoggerService.log('Inside if condition');
          this.onSelectField(this.finalContainer?.data[index + 1]);
          this.openPopover(this.selectedCompData);
        }
        index++;
        return;
      }
      index++;
    }
  }

  closeAll() {
    if (this.localityPopover) {
      this.localityPopover?.close();
    }
    if (this.checkinDatePopover) {
      this.checkinDatePopover?.close();
    }
    if (this.dateRangePopover) {
      this.dateRangePopover?.close();
    }
    if (this.checkinTimePopover) {
      this.checkinTimePopover?.close();
    }
    if (this.hoursPopover) {
      this.hoursPopover?.close();
    }
    if (this.roomGuestPopover) {
      this.roomGuestPopover?.close();
    }
    if (this.roomGuestPopover) {
      this.roomGuestPopover?.close();
    }
  }

  openPopover(selectedCompData: SearchCompDataType) {
    selectedCompData.restrictions = {};
    switch (selectedCompData?.containerItem?.uid) {
      case this.UID_ENUMS.DESTINATION_AUTOCOMPLETE:
        this.localityPopover?.open();
        return;
      case this.UID_ENUMS.CHECKIN_DATE_DATEPICKER:
        this.checkinDatePopover?.open();
        return;
      case this.UID_ENUMS.CHECKIN_CHECKOUT_DATEPICKER:
        this.dateRangePopover?.open();
        return;
      case this.UID_ENUMS.CHECKIN_TIME:
        // TODO need to remove this code in future
        // this.checkinTimePopover.offsetWidth = 200;
        selectedCompData.containerItem.component = 'CheckInTimeComponent';
        this.checkinTimePopover?.open();
        return;
      case this.UID_ENUMS.HOUR:
        // this.hoursPopover.offsetWidth = 230;
        selectedCompData.containerItem.component = 'CheckInHourComponent';
        this.hoursPopover?.open();
        return;
      case this.UID_ENUMS.NEW_ROOM_GUEST_PICKER:
        // this.roomGuestPopover.offsetWidth = 150;
        this.roomGuestPopover?.open();
        return;
      case this.UID_ENUMS.NEW_GUEST_PICKER:
        selectedCompData.restrictions = {
          showOnlyGuestField: true,
        };
        // this.roomGuestPopover.offsetWidth = 150;
        this.roomGuestPopover?.open();
        return;
    }
  }

  async getCurrentLocation() {
    this.loaderService.show('Loading', {
      backdrop: true,
      duration: 5000,
    });

    const m = await import(
      '@app/services/util-services/lazy-services/geo-location-util.service'
    );
    const s = this.injector.get(m.GEO_API);
    const response: {
      lat: undefined;
      lng: undefined;
      errorMsg: undefined;
    } = await s.getCurrentLocation(environment?.webApp);
    if (response?.lng && response?.lat) {
      this.formGroup
        ?.get('DESTINATION_AUTOCOMPLETE_DISPLAY')
        ?.setValue('Near me', {});
      this.submit(response?.lat, response?.lng, true);
    } else {
      if (response?.errorMsg) {
      } else {
        // TODO handle
      }
    }
    this.loaderService.hide();
  }

  onSelectField(containerItem: ContainerItemModel): void {
    this.closeAll();
    if (this.UID_ENUMS.CHECKIN_TIME === containerItem?.uid) {
      this.setShortstayCheckinTimeOptions(containerItem);
    }
    this.selectedCompData = {
      container: this.finalContainer,
      containerItem,
      selectedValue: this.formGroup.get(containerItem?.name)?.value,
    };

    if (
      this.selectedCompData?.containerItem?.uid ===
      this.UID_ENUMS.NEW_GUEST_PICKER
    ) {
      this.selectedCompData.restrictions = {
        showOnlyGuestField: true,
      };
    }

    // this.openPopover(this.selectedCompData);
  }

  setShortstayCheckinTimeOptions(containerItem: ContainerItemModel) {
    const checkinDate: { title: string; value: DateModel } = this.formGroup.get(
      UID_CONSTANTS.CHECKIN_DATE_DATEPICKER,
    )?.value;
    const checkinTime: { title: string; value: any } = this.formGroup.get(
      UID_CONSTANTS.CHECKIN_TIME,
    )?.value;

    let setNewAvailableValue: boolean = Boolean(false);

    for (const checkinTimeOption of containerItem?.options) {
      if (
        this.dayjsDateUtilLibService.isValidCheckInTimeOption(
          checkinDate?.value?.dateObj,
          checkinTimeOption,
        )
      ) {
        checkinTimeOption.disabled = false;
      } else {
        checkinTimeOption.disabled = true;
        if (checkinTime?.value?.title === checkinTimeOption.title) {
          setNewAvailableValue = true;
        }
      }
    }

    if (setNewAvailableValue) {
      const foundedOption: ContainerItemOption = containerItem?.options?.find(
        (item) => !item.disabled,
      );

      if (foundedOption) {
        this.setFieldValue(
          {
            _id: foundedOption?._id as string,
            title: foundedOption?.title,
            description: foundedOption?.description,
            value: foundedOption,
            fieldConfig: {
              uid: containerItem?.uid,
              name: containerItem?.name,
            },
          },
          {
            container: this.finalContainer,
            containerItem,
          },
        );
      }
    }
  }

  setFieldValue(
    selectedValue: SelectedItem,
    selectedCompData: {
      container: ContainerModel;
      containerItem: ContainerItemModel;
    },
  ) {
    this.formGroup
      .get(selectedCompData?.containerItem?.name)
      .setValue(selectedValue);
    this.formGroup
      .get(selectedCompData?.containerItem?.name + '_DISPLAY')
      .setValue(
        this.formHelperService.getFormDisplayValue(
          selectedValue,
          selectedCompData.container,
          selectedCompData.containerItem,
        ),
      );
  }

  createFormGroupFromCustomField(fields: ContainerItemModel[]) {
    // TODO Need to think about the type of group items
    const groupItems: any = {};

    for (const field of fields) {
      if (
        this.finalContainer?.selectedValues &&
        this.finalContainer?.selectedValues[field.name]?.value
      ) {
        let selectedValue;
        switch (field?.uid) {
          case UID_CONSTANTS.CHECKIN_DATE_DATEPICKER:
            selectedValue = JSON.parse(
              JSON.stringify(this.finalContainer?.selectedValues[field.name]),
            );

            selectedValue.value =
              this.dayjsDateUtilLibService.convertStringDateToDateModel(
                selectedValue?.value?.string,
                'YYYY-MM-DD',
              );
            break;
          case UID_CONSTANTS.CHECKIN_CHECKOUT_DATEPICKER:
            selectedValue = JSON.parse(
              JSON.stringify(this.finalContainer?.selectedValues[field.name]),
            );
            if (selectedValue?.value?.from) {
              selectedValue.value.from =
                this.dayjsDateUtilLibService.convertStringDateToDateModel(
                  selectedValue?.value?.from?.string,
                  'YYYY-MM-DD',
                );
            }
            if (selectedValue?.value?.to) {
              selectedValue.value.to =
                this.dayjsDateUtilLibService.convertStringDateToDateModel(
                  selectedValue?.value?.to?.string,
                  'YYYY-MM-DD',
                );
            }
            break;
          default:
            selectedValue = Object.assign(
              {},
              this.finalContainer.selectedValues[field.name],
            );
            break;
        }
        groupItems[field.name] = this.createFormControl(field, selectedValue);
        groupItems[field.name + '_DISPLAY'] = this.createFormControl(
          field,
          this.formHelperService.getFormDisplayValue(
            selectedValue,
            this.finalContainer,
            field,
          ),
        );
      } else {
        // TODO we can set some default value
        groupItems[field.name] = this.createFormControl(field, null);
        groupItems[field.name + '_DISPLAY'] = this.createFormControl(
          field,
          null,
        );
      }
    }

    return this.fb.group(groupItems);
  }

  createFormControl(
    field: ContainerItemModel,
    selectedValue:
      | SelectedItem
      | { label1: string; label2?: string; label3?: string; label4?: string }
      | string,
  ): FormControl {
    const validators: ValidatorFn[] = this.createValidators(field);
    return this.fb.control(selectedValue, validators);
  }

  createValidators(field: ContainerItemModel): ValidatorFn[] {
    const validators: ValidatorFn[] = [];
    if (field.required) {
      validators.push(Validators.required);
    }
    return validators;
  }

  submit(lat?: number, lng?: string, isNearMe?: boolean): void {
    const requestBody: NewRequestBodyModel = new NewRequestBodyModel();

    if (lat && lng) {
      // TODO
      requestBody.coordinates = {
        LAT: lat,
        LNG: lng,
      };
    } else {
      if (this.formGroup?.get('DESTINATION_AUTOCOMPLETE')?.invalid) {
        this.formGroup?.markAllAsTouched();
        this.toastService.error('Please select City / Locality / Property');
        return;
      }
    }

    this.dateRangePopover?.close();
    this.checkinDatePopover?.close();
    this.checkinTimePopover?.close();
    this.hoursPopover?.close();
    this.roomGuestPopover?.close();
    this.localityPopover?.close();

    requestBody.formValues = this.formGroup.getRawValue();
    requestBody.feature = this.finalContainer?.feature;

    this.analyticsEventService.fireSearchEvent(
      requestBody?.feature?.type,
      requestBody?.feature?.page,
      requestBody,
    );

    this.submitFormSubscription$ = this.searchFormService
      .submitFormData('experiences/validate-form-data', requestBody)
      .subscribe({
        next: (result: ApiResponseBody) => {
          if (
            this.router?.url.includes('/feature/list') &&
            result?.routerConfig?.nextUrl?.includes('feature/list')
          ) {
            if (isNearMe) {
              this.fireSearchQueryEvent(result, true, true, LIST_SEARCH_EVENT);
            } else {
              this.fireSearchQueryEvent(result, true, false, LIST_SEARCH_EVENT);
            }
          } else if (
            this.router?.url.includes('/feature/list') &&
            (result?.routerConfig?.nextUrl?.includes('feature/detail') ||
              result?.routerConfig?.nextUrl?.includes(
                'feature/activity-detail',
              ))
          ) {
            this.navigateTo(result, false);
          } else if (
            (this.router?.url.includes('/feature/detail') &&
              result?.routerConfig?.nextUrl?.includes('feature/detail')) ||
            (this.router?.url.includes('/feature/activity-detail') &&
              result?.routerConfig?.nextUrl?.includes(
                'feature/activity-detail',
              ))
          ) {
            this.fireSearchQueryEvent(result, true, false, DETAIL_SEARCH_EVENT);
          } else if (
            (this.router?.url.includes('/feature/detail') ||
              this.router?.url.includes('/feature/activity-detail')) &&
            result?.routerConfig?.nextUrl?.includes('feature/list')
          ) {
            this.fireSearchQueryEvent(result, false, true, LIST_SEARCH_EVENT);
          } else if (
            requestBody.feature.page === PAGE_TYPES.HOME_PAGE ||
            requestBody.feature.page === PAGE_TYPES.FEATURE_HOME_PAGE
          ) {
            this.navigateTo(result, false);
          } else {
            this.navigateTo(result, false);
          }
        },
        error: (errorResponse: HttpErrorResponse) => {
          this.toastService.showApiError(errorResponse);
        },
      });
  }

  fireSearchQueryEvent(
    apiResponse: ApiResponseBody,
    samePage: boolean,
    resetLayoutData: boolean,
    searchEvent: string,
  ) {
    if (searchEvent === DETAIL_SEARCH_EVENT) {
      this.eventService.searchQueryChangedOnDetailPageEvent.emit({
        queryParams: apiResponse?.routerConfig?.queryParamObject,
        resetLayoutData,
      });
    } else {
      this.eventService.searchQueryChangeEvent.emit({
        queryParams: apiResponse?.routerConfig?.queryParamObject,
        resetLayoutData,
      });
      this.navigateTo(apiResponse, samePage);
    }
  }

  /*fireSearchQueryEvent(apiResponse: ApiResponseBody) {
    this.eventService.searchQueryChangeEvent.emit({
      queryParams: apiResponse?.routerConfig?.queryParamObject,
    });
    this.navigateTo(apiResponse, true);
  }*/

  navigateTo(apiResponse: ApiResponseBody, samePage: boolean) {
    if (!apiResponse?.routerConfig?.nextUrl) {
      // TODO handle this case
    }
    if (apiResponse?.routerConfig?.nextUrl?.indexOf('?') > -1) {
      const splitUrl: string[] = apiResponse?.routerConfig?.nextUrl?.split('?');
      if (samePage) {
        this.router
          .navigate(['.'], {
            relativeTo: this.route,
            queryParams: apiResponse?.routerConfig?.queryParamObject,
          })
          .then();
      } else {
        this.router
          .navigateByUrl(
            `${splitUrl[0]}?${apiResponse?.routerConfig?.queryParams}`,
          )
          .then();
      }
    } else {
      this.router
        .navigateByUrl(
          `${apiResponse?.routerConfig?.nextUrl}?${apiResponse?.routerConfig?.queryParams}`,
        )
        .then();
    }
  }

  enquriyNow() {
    this.openContactUsForm();
  }

  openContactUsForm() {
    from(
      import(
        '@app/new-ui-lib/b2b-cards/components/b2b-contact-us-form-card/b2b-contact-us-form-card.component'
      ).then((c) => c.B2bContactUsFormCardComponent),
    ).subscribe({
      next: async (componentRef: ComponentRef) => {
        const modal: HTMLIonModalElement = await this.modalController.create({
          component: componentRef,
          cssClass: 'enquiry-modal',
        });

        modal.onDidDismiss().then((result: OverlayEventDetail<any>) => {});

        return await modal.present();
      },
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe();
  }

  ionViewDidLeave() {
    this.unsubscribe();
  }

  unsubscribe() {
    if (this.submitFormSubscription$) {
      this.submitFormSubscription$.unsubscribe();
    }
    if (this.initAPISubscription$) {
      this.initAPISubscription$.unsubscribe();
    }
  }
}
